import React, { Component } from 'react';
import { Grid, Segment, Form, Button, Header, Divider } from 'semantic-ui-react';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import * as SimpleReactValidator from 'simple-react-validator';
import Loading from '../Loading';
import MessageBox from '../../ui/MessageBox';
import { NotificationManager } from 'react-notifications';
import { getIdentityManager, createOrUpdateIdentity } from '../../utils/rest';

const initialState = {
    limId: 0,
    limTemplateName: "",
    limEntityId: "",
    limActive: "Y"
}

class AddIdentityManager extends Component {

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            loading: true,
            initialState: initialState,
            identityManager: initialState,
            errorMessage: [],
            notifications: [],
            open: false
        }
    }

    componentDidMount() {
        if (this.props.params.id > 0) {
            this.props.addItem("helpFile", "admin_user-edit.md");
            getIdentityManager(this.props.params.id).then(response => {
                if (response !== null) {
                    this.setState({ identityManager: response, loading: false });
                }
            })
        } else {
            this.props.addItem("helpFile", "admin_add-user.md");
            this.setState({ loading: false })
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleChange = (e) => {
        this.setState({
            identityManager: {
                ...this.state.identityManager,
                [e.target.name]: e.target.value
            }
        })
    }

    handleCheckbox = (e, { name, checked }) => {
        this.setState({
            identityManager: {
                ...this.state.identityManager,
                [name]: (checked) ? "Y" : "N"
            }
        });
    }

    reset = (e) => {
        e.preventDefault();
        this.setState({
            identityManager: this.state.initialState
        });
    }

    close = () => {
        this.setState({
            open: false
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.validator.allValid()) {
            this.setState({
                loading: true
            });
            createOrUpdateIdentity(this.state.identityManager).then(response => {
                    if (response !== null) {
                        NotificationManager.success('Success', 'Updated successfully.');
                        this.setState({
                            loading: false
                        }, () => { this.props.history.push("/identity") });
                    }else{
                        this.setState({ loading: false })
                    }
            }).catch((error) => {
                this.setState({ loading: false })
            })
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                open: true
            })
            this.forceUpdate();
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        const { activeIndex } = this.state
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Admnistration" child={[{ name: "Identity", url: "/identity" }, { name: this.props.params.id > 0 ? "Edit Identity" : "Add Identity", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Segment.Group>
                                    <Segment>
                                        <Header as="h4">Template Details</Header>
                                        <Divider></Divider>
                                        <Form.Group>
                                            <Form.Field width={5} className="required">
                                                <label>Template Name:</label>
                                                <Form.Input placeholder='Template Name' required={true} value={this.state.identityManager.limTemplateName || ''} name="limTemplateName" onChange={this.handleChange} />
                                                {this.validator.message('Template Name', this.state.identityManager.limTemplateName, 'required')}
                                            </Form.Field>
                                            <Form.Field width={5} className="required">
                                                <label>Entity Id:</label>
                                                <Form.Input placeholder='Entity Id' value={this.state.identityManager.limEntityId || ''} name="limEntityId" onChange={this.handleChange} />
                                                {this.validator.message('Entity Id', this.state.identityManager.limEntityId, 'required')}
                                            </Form.Field>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Field width={4}>
                                                <Form.Checkbox label="Active Status (Is Template Active?)" checked={this.state.identityManager.limActive === 'Y' ? true : false} name="limActive" onChange={this.handleCheckbox} />
                                            </Form.Field>
                                        </Form.Group>
                                    </Segment>
                                </Segment.Group>
                                <Form.Group>
                                    <Form.Field width={16}>
                                        <Button.Group width={2} className="small right floated">
                                            <Button onClick={this.reset}>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit} >{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={11} open={this.state.open} close={this.close} required={this.state.errorMessage} />
            </div>
        );
    }
}

export default AddIdentityManager;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/AddIdentityManager.js